(() => {
'use strict';
const configElement=document.getElementById('ALZConfig');
if(!configElement)return;
const config=JSON.parse(configElement.textContent);
const strings=config.strings;
const root=(window.Shopify?.routes?.root||config.root||'/').replace(/\/?$/,'/');
const dialog=document.getElementById('ALZBag');
const bagContent=dialog?.querySelector('[data-bag-content]');
const bagBottom=dialog?.querySelector('[data-bag-bottom]');
const bagError=dialog?.querySelector('[data-bag-error]');
const catalogs=new WeakMap();
let cartBusy=false,bagRequest=0,toastTimer;
const currencyCode=config.currency||'USD';
const currency=new Intl.NumberFormat(config.locale||'en',{style:'currency',currency:currencyCode,currencyDisplay:'narrowSymbol'});
const money=cents=>currency.format(Number(cents)/100)+' '+currencyCode;
const node=(tag,className,text)=>{const element=document.createElement(tag);if(className)element.className=className;if(text!==undefined)element.textContent=text;return element;};
const request=async(url,options={})=>{
 const controller=new AbortController();
 const timeout=window.setTimeout(()=>controller.abort(),15000);
 try{
  const response=await fetch(url,{cache:'no-store',...options,credentials:'same-origin',headers:{Accept:'application/json',...options.headers},signal:controller.signal});
  const data=await response.json();
  if(!response.ok){const error=new Error(typeof data.description==='string'?data.description:typeof data.message==='string'?data.message:strings.error);error.serverResponse=true;throw error;}
  return data;
 }finally{window.clearTimeout(timeout);}
};
const messageFor=error=>error.serverResponse?error.message:strings.networkError;
const notify=text=>{
 const toast=document.querySelector('[data-toast]');if(!toast)return;
 toast.textContent=text;toast.classList.add('is-visible');window.clearTimeout(toastTimer);
 toastTimer=window.setTimeout(()=>toast.classList.remove('is-visible'),3500);
};
const setBusy=busy=>{
 cartBusy=busy;
 if(dialog){dialog.setAttribute('aria-busy',String(busy));dialog.querySelectorAll('[data-line-change],[data-line-input],button[name="checkout"]').forEach(button=>button.disabled=busy);}
};
const fallbackLink=()=>{const a=node('a','text-link',strings.viewBag);a.href=config.cartUrl;return a;};
const renderCart=cart=>{
 bagContent.replaceChildren();bagError.textContent='';
 document.querySelectorAll('[data-cart-count]').forEach(element=>element.textContent=cart.item_count);
 bagBottom.hidden=cart.item_count===0;
 if(!cart.items.length){
  const empty=node('div','empty-state');empty.append(node('h3','',strings.empty),node('p','',strings.emptyBody));
  const link=node('a','button',strings.continue);link.href=config.shopUrl;empty.append(link);bagContent.append(empty);return;
 }
 cart.items.forEach(item=>{
  const line=node('div','cart-line');
  const imageLink=node('a','cart-image');imageLink.href=item.url;
  const src=item.featured_image?.url||item.image;
  if(src){const image=node('img');image.src=src;image.alt=item.featured_image?.alt||item.product_title;image.width=160;image.height=190;image.loading='lazy';imageLink.append(image);}
  const info=node('div','cart-line-details'),title=node('h2'),titleLink=node('a','',item.product_title);titleLink.href=item.url;title.append(titleLink);info.append(title);
  if(item.variant_title)info.append(node('p','',item.variant_title));
  if(item.properties)Object.entries(item.properties).forEach(([key,value])=>{if(value&&!key.startsWith('_'))info.append(node('p','',key+': '+value));});
  const quantity=node('div','bag-quantity'),minus=node('button','','−');
  minus.type='button';minus.dataset.lineChange=item.key;minus.dataset.quantity=String(Math.max(0,item.quantity-1));minus.setAttribute('aria-label',strings.quantity+' − '+item.product_title);
  const input=node('input');input.type='number';input.min='0';input.step='1';input.value=item.quantity;input.dataset.lineInput=item.key;input.dataset.previousQuantity=item.quantity;input.setAttribute('aria-label',strings.quantity+' — '+item.product_title);
  const plus=node('button','','+');plus.type='button';plus.dataset.lineChange=item.key;plus.dataset.quantity=String(item.quantity+1);plus.setAttribute('aria-label',strings.quantity+' + '+item.product_title);
  quantity.append(minus,input,plus);info.append(quantity);
  const remove=node('button','bag-remove',strings.remove);remove.type='button';remove.dataset.lineChange=item.key;remove.dataset.quantity='0';remove.setAttribute('aria-label',strings.remove+' — '+item.product_title);info.append(remove);
  (item.line_level_discount_allocations||[]).forEach(discount=>info.append(node('p','discount-label',discount.discount_application.title+' (−'+money(discount.amount)+')')));
  const price=node('div','cart-line-price');if(item.original_line_price!==item.final_line_price)price.append(node('s','',money(item.original_line_price)));price.append(node('strong','',money(item.final_line_price)));
  line.append(imageLink,info,price);bagContent.append(line);
 });
 const orderDiscounts=(cart.cart_level_discount_applications||[]).filter(discount=>discount.target_type==='line_item');
 const itemSubtotal=Number.isFinite(cart.items_subtotal_price)?cart.items_subtotal_price:cart.items.reduce((total,item)=>total+Number(item.final_line_price),0);
 const orderSavings=orderDiscounts.reduce((total,discount)=>total+Number(discount.total_allocated_amount),0);
 const subtotalRow=dialog.querySelector('[data-bag-items-row]');
 subtotalRow.hidden=orderDiscounts.length===0;
 dialog.querySelector('[data-bag-items-total]').textContent=money(itemSubtotal);
 const discountRows=dialog.querySelector('[data-bag-discounts]');
 discountRows.replaceChildren();
 orderDiscounts.forEach(discount=>{
  const row=node('div','subtotal');
  row.append(node('span','',discount.title),node('span','','−'+money(discount.total_allocated_amount)));
  discountRows.append(row);
 });
 dialog.querySelector('[data-bag-total]').textContent=money(Math.max(0,itemSubtotal-orderSavings));
};
const openBag=async()=>{
 if(!dialog?.showModal){window.location.assign(config.cartUrl);return;}
 if(!dialog.open)dialog.showModal();
 if(cartBusy){if(!bagContent.children.length)bagContent.append(node('p','bag-loading',strings.loading));return;}
 const id=++bagRequest;bagError.textContent='';bagBottom.hidden=true;bagContent.replaceChildren(node('p','bag-loading',strings.loading));
 try{const cart=await request(root+'cart.js');if(id===bagRequest)renderCart(cart);}
 catch(error){if(id!==bagRequest)return;bagContent.replaceChildren(node('p','bag-loading',messageFor(error)),fallbackLink());}
};
const changeLine=async(key,quantity)=>{
 if(cartBusy||!Number.isInteger(quantity)||quantity<0)return;
 setBusy(true);++bagRequest;bagError.textContent='';let changed=false;
 try{
  await request(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
  changed=true;
  const cart=await request(root+'cart.js');
  renderCart(cart);
  const mainCart=document.getElementById('ALZCartForm');if(mainCart)mainCart.dataset.stale='true';
 }catch(error){
  bagError.textContent=messageFor(error);
  if(changed){bagBottom.hidden=true;bagContent.replaceChildren(fallbackLink());}
  else bagContent.querySelectorAll('[data-line-input]').forEach(input=>input.value=input.dataset.previousQuantity);
 }finally{setBusy(false);}
};
document.addEventListener('submit',async event=>{
 const form=event.target;
 if(form.id==='ALZCartForm'&&form.dataset.stale==='true'){event.preventDefault();window.location.assign(config.cartUrl);return;}
 if(!form.matches('[data-alz-add]'))return;
 event.preventDefault();if(cartBusy)return;
 const data=new FormData(form),message=form.querySelector('[data-form-message]'),button=form.querySelector('button[type="submit"]');
 if(!data.get('id')){if(message)message.textContent=strings.sizeRequired;form.querySelector('[name="id"]')?.focus();return;}
 if(!form.reportValidity())return;
 const originalLabel=button.innerHTML;let added=false;
 setBusy(true);++bagRequest;button.disabled=true;button.textContent=strings.adding;form.setAttribute('aria-busy','true');if(message)message.textContent='';
 try{
  await request(root+'cart/add.js',{method:'POST',body:data});added=true;notify(strings.added);
  const cart=await request(root+'cart.js');renderCart(cart);
  if(dialog?.showModal){if(!dialog.open)dialog.showModal();}else window.location.assign(config.cartUrl);
 }catch(error){
  const errorText=added?strings.addedError:messageFor(error);
  if(message){message.textContent=errorText+' ';message.append(fallbackLink());}
  if(dialog?.open){bagError.textContent=errorText;if(!bagBottom.hidden)bagBottom.hidden=true;bagContent.replaceChildren(fallbackLink());}
 }finally{button.innerHTML=originalLabel;button.disabled=false;form.removeAttribute('aria-busy');setBusy(false);}
});
const updateImage=(container,url,alt,zoomUrl)=>{
 const image=container.querySelector('[data-product-image]');if(!image||!url)return;
 image.removeAttribute('srcset');image.src=url;if(alt)image.alt=alt;
 const zoom=container.querySelector('[data-product-zoom]');if(zoom)zoom.href=zoomUrl||url;
 container.querySelectorAll('[data-image-url]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.imageUrl===url)));
};
document.addEventListener('change',event=>{
 const input=event.target;
 if(input.matches('[data-line-input]')){
  if(!input.checkValidity()||input.value===''){input.value=input.dataset.previousQuantity;return;}
  changeLine(input.dataset.lineInput,Number(input.value));
 }
 if(input.matches('[data-variant-picker]')){
  const option=input.selectedOptions[0],page=input.closest('[data-product-page]');if(!page||!option.value)return;
  page.querySelector('[data-product-price]').textContent=option.dataset.price;
  const compare=page.querySelector('[data-product-compare]');compare.textContent=option.dataset.compare;compare.hidden=option.dataset.onSale!=='true';
  const button=page.querySelector('[data-alz-add] button[type="submit"]');button.disabled=option.dataset.available!=='true';button.textContent=option.dataset.available==='true'?strings.add:strings.soldOut;
  updateImage(page,option.dataset.image,option.dataset.imageAlt,option.dataset.zoomUrl);
  const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);
 }
 if(input.matches('[data-sort]'))applyFilters(input.closest('[data-catalog]'));
});
document.addEventListener('click',event=>{
 const target=event.target.closest('a,button');if(!target)return;
 if(target.matches('[data-open-bag]')){event.preventDefault();openBag();}
 if(target.matches('[data-close-bag]'))dialog.close();
 if(target.matches('[data-line-change]'))changeLine(target.dataset.lineChange,Number(target.dataset.quantity));
 if(target.matches('[data-image-url]'))updateImage(target.closest('[data-product-page]'),target.dataset.imageUrl,target.dataset.imageAlt,target.dataset.zoomUrl);
 const catalog=target.closest('[data-catalog]');if(!catalog||!catalogs.has(catalog))return;
 const state=catalogs.get(catalog);
 if(target.matches('[data-category-filter]')){event.preventDefault();state.category=target.dataset.categoryFilter;applyFilters(catalog,true);}
 if(target.matches('[data-team-filter]')){state.team=target.dataset.teamFilter;applyFilters(catalog,true);}
 if(target.matches('[data-reset-filters]')){event.preventDefault();state.category='all';state.team='all';applyFilters(catalog,true);}
});
document.addEventListener('keydown',event=>{if(event.key===' '&&event.target.matches('[data-category-filter]')){event.preventDefault();event.target.click();}});
dialog?.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
dialog?.addEventListener('close',()=>{if(document.getElementById('ALZCartForm')?.dataset.stale==='true')window.location.reload();});
const applyFilters=(catalog,updateUrl=false)=>{
 if(!catalog)return;
 const state=catalogs.get(catalog),cards=[...catalog.querySelectorAll('[data-product-card]')],sort=catalog.querySelector('[data-sort]').value;
 let visible=0;
 cards.forEach((card,index)=>{
  if(!card.dataset.index)card.dataset.index=String(index+1);
  card.hidden=!(state.category==='all'||card.dataset.category===state.category)||!(state.team==='all'||card.dataset.team===state.team);
  if(!card.hidden)visible++;
 });
 cards.sort((a,b)=>sort==='price-low'?Number(a.dataset.price)-Number(b.dataset.price):sort==='price-high'?Number(b.dataset.price)-Number(a.dataset.price):sort==='title'?a.dataset.title.localeCompare(b.dataset.title):Number(a.dataset.index)-Number(b.dataset.index));
 const grid=catalog.querySelector('[data-product-grid]');cards.forEach(card=>grid.append(card));
 catalog.querySelector('[data-catalog-empty]').hidden=visible>0;
 const count=catalog.querySelector('[data-catalog-count]');count.textContent=visible+' '+strings.products;count.setAttribute('aria-live','polite');
 catalog.querySelectorAll('[data-category-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.categoryFilter===state.category)));
 catalog.querySelectorAll('[data-team-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.teamFilter===state.team)));
 if(updateUrl){
  const url=new URL(window.location.href);
  if(state.category==='all')url.searchParams.delete('category');else url.searchParams.set('category',state.category);
  if(state.team==='all')url.searchParams.delete('team');else url.searchParams.set('team',state.team);
  window.history.replaceState({},'',url);
 }
};
const loadRemaining=async catalog=>{
 const initialNext=catalog.querySelector('[data-next-page]');if(!initialNext)return;
 let next=initialNext.href;const visited=new Set();
 try{
  while(next&&!visited.has(next)){
   visited.add(next);
   const url=new URL(next,window.location.origin);url.searchParams.set('section_id',catalog.dataset.sectionId);
   const controller=new AbortController(),timeout=window.setTimeout(()=>controller.abort(),15000);let html;
   try{const response=await fetch(url,{credentials:'same-origin',signal:controller.signal});if(!response.ok)throw new Error(strings.catalogError);html=await response.text();}finally{window.clearTimeout(timeout);}
   const doc=new DOMParser().parseFromString(html,'text/html'),incoming=doc.querySelector('[data-catalog]');if(!incoming)throw new Error(strings.catalogError);
   const existing=new Set([...catalog.querySelectorAll('[data-product-card]')].map(card=>card.dataset.productId));
   incoming.querySelectorAll('[data-product-card]').forEach(card=>{if(!existing.has(card.dataset.productId))catalog.querySelector('[data-product-grid]').append(document.importNode(card,true));});
   const nextLink=incoming.querySelector('[data-next-page]');next=nextLink?new URL(nextLink.getAttribute('href'),window.location.origin).href:null;
   applyFilters(catalog);
  }
  const pagination=catalog.querySelector('[data-pagination]');if(pagination)pagination.hidden=true;
 }catch{catalog.querySelector('[data-catalog-error]').textContent=strings.catalogError;}
};
const initialize=context=>{
 context.querySelectorAll('[data-catalog]').forEach(catalog=>{
  if(catalogs.has(catalog))return;
  const params=new URLSearchParams(window.location.search),requestedCategory=params.get('category'),requestedTeam=({rangers:'ny',bruins:'bos'}[params.get('team')] || params.get('team'));
  const category=['tees','sweatshirts','hats'].includes(requestedCategory)?requestedCategory:'all',team=['ny','bos','ca','mn','to','nj','mi'].includes(requestedTeam)?requestedTeam:'all';
  catalogs.set(catalog,{category,team});applyFilters(catalog);loadRemaining(catalog);
 });
};
initialize(document);
document.querySelectorAll('[data-variant-picker]').forEach(input=>{const option=input.selectedOptions[0];if(option?.value&&option.dataset.available!=='true'){const button=input.closest('[data-product-page]')?.querySelector('[data-alz-add] button[type="submit"]');if(button){button.disabled=true;button.textContent=strings.soldOut;}}});
document.addEventListener('shopify:section:load',event=>initialize(event.target));
window.addEventListener('pageshow',event=>{if(event.persisted)request(root+'cart.js').then(cart=>{if(dialog?.open)renderCart(cart);else document.querySelectorAll('[data-cart-count]').forEach(element=>element.textContent=cart.item_count);}).catch(()=>{if(dialog?.open){bagBottom.hidden=true;bagError.textContent=strings.networkError;}});});
})();
